import {calculateAverageRGB, calculateContrast} from "../utilities/color";
import {BaseModule} from "./base.module";
import Color from 'colorjs.io';

export class ColorModule extends BaseModule {
    constructor(extraConfiguration = {}) {
        super();

        this.configuration = Object.assign({}, extraConfiguration);

        // CSS classes for dynamic theme switching
        this.lightThemeClass = "dynamic-light";
        this.darkThemeClass = "dynamic-dark";

        this.setEventListeners();
    }

    setEventListeners() {
        if (typeof document !== "undefined") {
            let configurationElement = document;
            this.triggerEventOnElement("constructor", configurationElement, this);
            this.triggerEventOnElement("constructor.color-module", configurationElement, this);
        }
    }

    initialize() {
        // Listen for lazy-loaded images to analyze their colors
        document.addEventListener("lazyloaded", async (lazyLoadEvent) => {
            if (lazyLoadEvent.target && lazyLoadEvent.target.dataset && lazyLoadEvent.target.dataset.bg) {
                const backgroundElement = lazyLoadEvent.target;

                // Skip elements inside jumbotrons (handled by JumbotronColorModule)
                const jumbotronParent = backgroundElement.closest('.jumbotron');
                // Note: image grid case.
                if (!jumbotronParent) {
                    await this.measureImage(backgroundElement, backgroundElement);
                }
            }
            if (lazyLoadEvent.target && lazyLoadEvent.target.dataset && lazyLoadEvent.target.dataset.src) {
                await this.measureImage(lazyLoadEvent.target, lazyLoadEvent.target);
            }

        });
    }

    measureImage(backgroundElement, element) {
        // element could be jumbotron
        let canvas = document.createElement("canvas");
        let context = canvas.getContext("2d");

        let image = new Image();
        if (
            backgroundElement.dataset
            &&
            backgroundElement.dataset.src
        ) {
            image.src = backgroundElement.dataset.src;
        }
        if (
            backgroundElement.dataset
            &&
            backgroundElement.dataset.image
        ) {
            image.src = backgroundElement.dataset.image;
        }

        // Process image once it's loaded
        image.addEventListener('load',  () => {
            canvas.width = image.width;
            canvas.height = image.height;
            // some debugging stuff here for now, until onMeasured, cuz the Promise thingy is a bit annoying to debug for now
            // console.log('da image', image);
            const {r, g, b} = calculateAverageRGB(canvas, context, image, image.width, image.height);
            const {whiteContrast, blackContrast} = calculateContrast(r, g, b);
            console.log(`whiteContrast, blackContrast`, whiteContrast, blackContrast)
            // Choose text color based on contrast values
            // console.log('logging the image', image);
            // document.documentElement.insertAdjacentElement('beforeend', image)

            let tint = this.onMeasured([r, g, b], element);
            let contrastingTint = null;
            switch (tint) {
                case 'light':
                    contrastingTint = 'dark';
                    break;
                case 'dark':
                    contrastingTint = 'light';
                    break;
            }
            console.log('element, tint values now', element, tint);
            if (element && tint) {
                console.log('element, tint are present', element, tint);
                //dynamic-light or dynamic-dark
                element.classList.add(`dynamic-${tint}`);
                let closestNexusImg = element.closest('nexus-img');
                if (
                    closestNexusImg
                ) {
                    closestNexusImg.bg = contrastingTint;
                }
            }
        });

    }

    onMeasured(rgb, element) {
        const [r, g, b] = rgb;

        // Calculate whether white or black text would have better contrast
        const {whiteContrast, blackContrast} = calculateContrast(r, g, b);

        // Choose text color based on contrast values
        let luminosityString = whiteContrast > blackContrast ? 'white' : 'black';

        console.log('contrasts', whiteContrast, blackContrast, luminosityString);

        // alert(luminosityString);
        switch (luminosityString) {
            case 'white':
                return 'dark';
            case 'black':
                return 'light';
        }

    }

    setRGBAndGrayScale(rgba, element, grayScale, grayScaleInversion) {
        // Set CSS variables that can be used in stylesheets
        element.style.setProperty("--bg-background-rgb", rgba);
        element.style.setProperty("--bg-background-grayscale", grayScale.toFixed(0));
        element.style.setProperty("--bg-background-grayscale-inversion", grayScaleInversion.toFixed(0));
    }

    setTheme(element, modeToSet) {
        // Remove all theme classes and add the appropriate one
        const themeClasses = [this.lightThemeClass, this.darkThemeClass];
        element.classList.remove(...themeClasses);
        element.classList.add('dynamic-' + modeToSet);
    }
}